import '../../App.css';
import React, { useContext, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';

function ModalEditarCompetencia({currentPage}) {
    const { EditarCompetencia, EdicaoCompetencia, setEdicaoCompetencia, ListaCompetencia, setModalEditarCompetencia, Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const handleChange = (event) => {
        setEdicaoCompetencia({ ...EdicaoCompetencia, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaCompetencia()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar competência</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarCompetencia(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome da competência</Form.Label>
                                    <Form.Control maxLength={100} defaultValue={EdicaoCompetencia.descricao} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarCompetencia(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={() => EditarCompetencia(currentPage)}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarCompetencia